import { render, staticRenderFns } from "./AddOrganisationToUserForm.vue?vue&type=template&id=5d9b309a&scoped=true&"
import script from "./AddOrganisationToUserForm.vue?vue&type=script&lang=js&"
export * from "./AddOrganisationToUserForm.vue?vue&type=script&lang=js&"
import style0 from "./AddOrganisationToUserForm.vue?vue&type=style&index=0&id=5d9b309a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b309a",
  null
  
)

export default component.exports